<template>
  <div>
    <BaseHeadline
      icon="mdi-file-document"
      :showOnMobile="true"
      :breadcrumbs="breadcrumbsData"
      :showBreadcrumbsOnMobile="true"
    >
    <template v-slot:headlineBtns>
      <v-btn
          v-if="documentsSelected.length > 0"
          color="secondary"
          depressed
          @click="downloadMerged"
          class="mr-2"
        >
        <v-icon :left="!$vuetify.breakpoint.mobile">mdi-download</v-icon>
          {{ !$vuetify.breakpoint.mobile ? "Last ned valgte" : "" }}
      </v-btn>
    </template>
    </BaseHeadline>

    <v-checkbox
          v-if="displaySelection"
          v-model="allSelected"
          indeterminate
          @change="handleAllSelected"
          label="Velg alle"
          class="mx-4"
        ></v-checkbox>

    <DocumentsList
      :documents="data"
      :loading="loading"
      :itemName="$route.params.building ? 'fileName' : 'name'"
      @click="clickBtn"
      @selection="selectedChanged"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import documentApi from "@/api/documentApi";
import { Breadcrumbs, ProjectObject } from "@/types/interface";

import {
  DocumentObject,
  DocumentsBreadcrumbs,
} from "@/types/documentInterface";

import DocumentsList from "@/components/shared/documents/DocumentsList.vue";

export default Vue.extend({
  data() {
    return {
      loading: true,
      project: {} as ProjectObject,
      documents: new Array<DocumentObject>(),
      documentsSelected: new Array<DocumentObject>(),
      breadcrumbs: new Array<DocumentsBreadcrumbs>(),
      displaySelection: false,
      allSelected: false
    };
  },
  async created() {
    await this.fetchData();
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.documents = [];
      this.displaySelection = false;
      if (this.$route.name === "ProjectBlueprintsUuid") {
        await documentApi
          .getDocumentsUuid(this.$route.params.id, this.$route.params.uuid)
          .then((repsonse) => {
            this.documents = repsonse.documents;
            this.displaySelection = this.documents.filter(d => d.extension === ".pdf").length > 0;
            this.breadcrumbs = repsonse.breadCrumbs;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        documentApi
          .getBlueprintsDocuments(this.$route.params.id)
          .then((repsonse) => {
            this.documents = repsonse.documents;
            this.displaySelection = this.documents.filter(d => d.extension === ".pdf").length > 0;
            this.loading = false;
            this.project = repsonse.project;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    clickBtn(document: DocumentObject) {
      if (!document.extension) {
        //Is folder
        this.$router.push({
          name: "ProjectBlueprintsUuid",
          params: { uuid: document.uuid },
        });
      } else {
        this.download(document);
      }
    },
    download(document) {
      documentApi.downloadDocument(document);
    },
    downloadMerged() {
      var fileName = "";
      if (this.documentsSelected.length > 1) {
        this.breadcrumbs.forEach(bc => {
          fileName += bc.title;
          if (!bc.last) { 
            fileName += " ";
          }
        });
        fileName += ".pdf";
      } else {
        fileName = this.documentsSelected[0].name;
      }
      documentApi.downloadMergedPdfs(this.documentsSelected, fileName);
    },
    async selectedChanged(document: DocumentObject) {
      var docs = this.documents;
      var doc = docs.find(d => d.uuid == document.uuid) as DocumentObject;
      if (doc) {
        doc.selected = document.selected;
      }
      this.documents = [...docs];
      this.documentsSelected = this.documents.filter(d => d.selected);
      this.allSelected = this.documents.findIndex(d => !d.selected) === -1;
    },
    async handleAllSelected() {
      var docs = this.documents;
      docs.forEach((doc: any) => {
        doc.selected = this.allSelected;
      });
      this.documents = [...docs];
      this.documentsSelected = this.documents.filter(d => d.selected);
    }
  },

  computed: {
    data(): Array<any> {
      if (this.$route.params.building && this.documents.length > 0) {
        this.$route.params.building;
        var building = (this as any).documents.find(
          (x) => x.name === this.$route.params.building
        );

        return building.list;
      }
      return this.documents;
    },
    breadcrumbsData(): Array<Breadcrumbs> {
      if (this.project) {
        var data = [
          {
            disabled: false,
            text: this.project.name,
            to: {
              name: "Project",
              params: { id: this.$route.params.id },
            },
            exact: true,
          },
          {
            disabled: this.$route.params.uuid ? false : true,
            text: "Tegninger",
            to: {
              name: "ProjectBlueprints",
            },

            exact: true,
          },
        ];

        if (this.$route.params.uuid && this.breadcrumbs.length >= 3) {
          var breadcrumbs = this.breadcrumbs;
          breadcrumbs.splice(0, 3);

          var breadcrumbsMaped = breadcrumbs.map((x) => {
            return {
              disabled: x.last,
              text: x.title,
              to: {
                name: "ProjectBlueprintsUuid",
                params: { uuid: x.id },
              },
              exact: true,
            };
          });

          return [...data, ...breadcrumbsMaped];
        }

        return data;
      }

      return [];
    },
    upload(): Vue & { value: string | null } {
      return this.$refs.upload as Vue & {
        value: "";
      };
    },
  },

  components: {
    BaseHeadline,
    DocumentsList,
  },
});
</script>

<style lang="scss">
.alertStyle {
  .v-alert__wrapper {
    .v-alert__icon.v-icon:after {
      background: transparent !important;
    }
  }
}
</style>
